import { render, staticRenderFns } from "./object-detail.vue?vue&type=template&id=28007170&scoped=true&"
import script from "./object-detail.vue?vue&type=script&lang=js&"
export * from "./object-detail.vue?vue&type=script&lang=js&"
import style0 from "./object-detail.vue?vue&type=style&index=0&lang=less&"
import style1 from "./object-detail.vue?vue&type=style&index=1&id=28007170&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28007170",
  null
  
)

export default component.exports